import { ROUTES } from '@shared/consts/routes';
import { BuildType } from '@shared/enums/build.type';
import { FooterMenu } from '../interfaces/footer-menu.interface';

export const Menu: FooterMenu[] = [
  {
    title: 'FOOTER_MENU.PARTS_SELECTION',
    categoryItems: [
      {
        title: 'FOOTER_MENU.LAXIMO_CATALOG',
        route: '/catalog/laximo',
      },
      {
        title: 'FOOTER_MENU.AUTODEALER_CATALOG',
        route: '/catalog/acat',
      },
      {
        title: 'FOOTER_MENU.SELECTION_BY_PARAMETERS',
        route: '/category/all',
      },
    ],
  },
  {
    title: 'FOOTER_MENU.ABOUT_COMPANY',
    categoryItems: [
      {
        title: 'FOOTER_MENU.CONTACTS_AND_WAREHOUSES',
        route: '/contacts',
      },
      {
        title: 'FOOTER_MENU.PRIVACY_POLICY',
        route: ROUTES.PRIVACY_POLICY,
        target: '_blank',
      },
      {
        title: 'FOOTER_MENU.PERSONAL_DATA_AGREEMENT',
        route: '/personal-data-agreement',
        target: '_blank',
      },
    ],
    columnFooterLink: {
      title: 'FOOTER_MENU.WORK_AT_US',
      route: ROUTES.WORK_AT_US,
      buildTypes: [BuildType.ru],
    },
  },
];
